import { environment } from "../../environments/environment";

export const NUM_NOTIFICATIONS = 5;
export const POLLING_INTERVAL = environment.NOTIFICATION_INTERVAL;
